module.exports = __webpack_public_path__ + "static/media/beauty.f700a504.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/beauty.jpg
// module id = 820
// module chunks = 3